<template>
  <bita-modal
    :id="modalId"
    title=" وضعیت (پیامک)"
    :isLoading="isLoading"
    :modal-lg="true"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">

          <div class="text-center">
            <div v-if="salons.length > 0" class="sms-active">
              <div class="title-sms-active"> پیامک های فعال </div>
              <table class="table mt-2">
                <thead>
                  <tr>
                    <th>سالن</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="salon in salons" :key="salon.id">
                    <td>{{ salon.name }}</td>
                    <td>
                      <span>
                          <a role='button' @click="onDelete(salon)" title='حذف'><span class='fas fa-times' style='color:red'></span></a>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center text-danger danger-sms-active">
              راننده پیامک فعالی ندارد!
            </div>
          </div>


          <div class="text-center">
            <div v-if="notifications.length > 0" class="show-sms-driver">
              <div class="title-sms-driver"> آخرین پیامک راننده </div>
              <table class="table mt-2" >
                <thead>
                  <tr>
                    <th> نام و نام خانوادگی  </th>
                    <th> شماره تماس </th>
                    <th> نوع </th>
                    <th> فعالیت </th>
                    <th> تاریخ ایجاد بار </th>
                    <th> سالن </th>
                    <th> مبدا </th>
                    <th> مقصد </th>
                    <th> تحویل در </th>
                    <th> تاریخ ایجاد </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="notification in notifications" :key="notification.id">
                    <td>
                      {{ notification.user ? notification.user.full_name : "-" }}
                    </td>
                    <td>{{ notification.phone }}</td>
                    <td>{{ notification.type }}</td>
                    <td>{{ notification.action }}</td>
                    <td>
                      {{ notification.request ? $getJalaliDateTime(notification.request.created_at) : "-" }}
                    </td>
                    <td>
                      {{ notification.request ? notification.request.salon.name : "-" }}
                    </td>
                    <td>
                      {{ notification.request ? `${notification.request.origin.province.name} / ${notification.request.origin.name}` : "-" }}
                    </td>
                    <td>
                      {{ notification.request ? `${notification.request.destination.province.name} / ${notification.request.destination.name}` : "-" }}
                    </td>
                    <td>
                      {{ notification.delivery_at ? $getJalaliDateTime(notification.delivery_at) : "-" }}
                    </td>
                    <td>
                      {{ notification.created_at ? $getJalaliDateTime(notification.created_at) : "-" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center text-danger danger-sms-driver">
              پیامکی برای راننده ارسال نشده!
            </div>
          </div>

        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    modalId: {},
    title: {},
    propsDriver: {},
  },
  data() {
    return {
      driver: {},
      isLoading: false,
      salons: [],
      notifications: [],
    };
  },
  watch: {
    propsDriver: function(_data) {
      this.driver = _data;
      this.getData();
      this.readData();
    },
  },
  methods: {
    readData(e) {
      this.isLoading = true;
      this.$persistClient("get", `drivers/${this.driver.user.id}/notifications`)
        .then((res) => {
          this.notifications = res.data.data;
        })
        .catch(() => {
          this.notifications = [];
        })
        .finally(() => (this.isLoading = false));
    },
    getData() {
      this.isLoading = true;
        this.$persistClient("get", `notification-settings?user_id=${this.driver.user.id}`)
        .then((res) => {
          this.salons = res.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onDelete(salonSelect) {
      this.isLoading = true;

      let salons =  this.salons.filter( (salon) => salon.id != salonSelect.id );
      let salon_ids = [];

      salons.forEach(salon => {
        salon_ids.push(salon.id);
      });

      this.$persistClient(
        "post",
        `notification-settings`, {
          salon_ids: salon_ids,
          user_id: this.driver.user.id,
        }
      )
        .then((res) => {
          this.getData();
          this.$izitoast("success", "عملیات موفق", res.data.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
        this.isLoading = false;


    },
  },
};
</script>

<style scoped>

  .danger-sms-active {
    border: 2px dashed black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 8px 0;
    margin-bottom: 10px;
  }

  .danger-sms-driver {
    border: 2px dashed black;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 8px 0;
  }

  .sms-active {
    border: 2px dashed black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-bottom: 20px;
  }
  .sms-active .title-sms-active {
    text-align: center;
    padding: 5px;
    color: #fff;
    background-color: #14a9d9;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .show-sms-driver {
    border: 2px dashed black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .show-sms-driver .title-sms-driver {
    text-align: center;
    padding: 5px;
    color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #14a9d9;
  }

</style>